import Component from "./Picture";
import Badge from "./components/Badge/PictureBadge";
import Counter from "./components/Counter/PictureCounter";
import Icon from "./components/Icon/PictureIcon";

interface IPictureExtensions {
    Badge: typeof Badge;
    Counter: typeof Counter;
    Icon: typeof Icon;
}

export const Picture: typeof Component & IPictureExtensions = Object.assign(
    Component,
    {
        Badge,
        Counter,
        Icon,
    },
);

export type { PictureProps } from "./types";
